(() => {
  'use strict';

  const selector = '[data-protein-filter-link]';

  function preserveFilters(link) {
    const url = new URL(link.href, window.location.origin);
    const params = new URLSearchParams(window.location.search);
    // A narrower collection may have fewer pages. Start at its first result.
    params.delete('page');
    url.search = params.toString();
    link.href = url.toString();
  }

  function refreshLinks() {
    document.querySelectorAll(selector).forEach(preserveFilters);
  }

  // Keep native navigation, keyboard use, and open-in-new-tab behavior intact.
  // Delegation also covers links replaced by the theme's AJAX facet filtering.
  ['click', 'auxclick', 'contextmenu', 'focusin'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const link = event.target.closest(selector);
      if (link) preserveFilters(link);
    });
  });

  document.addEventListener('collection:reloaded', refreshLinks);
  document.addEventListener('shopify:section:load', refreshLinks);
  refreshLinks();
})();
